module.exports = __webpack_public_path__ + "img/logo-full.be903a28.png";